import {ActivityTimeline} from '@/shared/components/ui/activity-timeline'
import {DataSection} from '@cypro/ui/components/ui/data-section'
import {EmptyState} from '@cypro/ui/components/ui/empty-state'
import {EventLog} from '@cypro/engine/schema'
import {useTranslate} from '@tolgee/react'

export function ResourceDrawerActivitiesSection({activities}: {activities: EventLog[] | undefined}) {
  const {t} = useTranslate('common')

  return (
    <DataSection>
      {!activities?.length && <EmptyState title={t('no_recorded_activity_yet')} />}

      {Boolean(activities?.length) && <ActivityTimeline activities={activities || []} />}
    </DataSection>
  )
}
